import React, { Component } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

// Config
import config from 'config';

// UI
import Router from 'components/Router';
import ErrorBoundary from 'components/ErrorBoundary';
import AnalyticsProvider from 'components/Analytics/AnalyticsProvider';

// Themes
import Theme from 'styles/theme';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

export default class App extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
  };

  render() {
    const { store } = this.props;

    return (
      <>
        <CssBaseline />
        <ErrorBoundary>
          <ThemeProvider theme={Theme}>
            <Provider store={store}>
              <AnalyticsProvider config={config}>
                <Router />
              </AnalyticsProvider>
            </Provider>
          </ThemeProvider>
        </ErrorBoundary>
      </>
    );
  }
}
